module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    staticClass: "component-preview",
    on: {
      "click": function($event) {
        _vm.$emit('click', $event);
      }
    }
  }, [(_vm.selectedImage) ? _c('img', {
    attrs: {
      "src": _vm.selectedImage
    }
  }) : (_vm.component.type === _vm.COMPONENT_NAME.caddy && _vm.component.config) ? _c('CaddyPreview', {
    attrs: {
      "caddy": _vm.caddyConfig,
      "markers": false
    }
  }) : (_vm.component.config && _vm.component.type === _vm.COMPONENT_NAME.ladder) ? _c('LadderPreview', {
    attrs: {
      "value": _vm.component.config
    }
  }) : (_vm.bigImgPath) ? _c('img', {
    attrs: {
      "src": _vm.bigImgPath
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../static/img/no_image.jpg")
    }
  }), _vm._v(" "), (!_vm.component.is_published) ? _c('div', {
    staticClass: "not-published abs absCenter"
  }, [_vm._v(_vm._s(_vm.$t("product.notPublished")))]) : _vm._e(), _vm._v(" "), (_vm.component.status) ? _c('div', {
    staticClass: "status",
    style: ({
      backgroundColor: _vm.getStatusColor(_vm.component.status.name)
    })
  }, [_vm._v("\n        " + _vm._s(_vm.$tradFor(_vm.component.status.terms.name)) + "\n    ")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ca02213","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/catalog/component-preview.vue
// module id = 3010
// module chunks = 0